/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicParameters
 */
export interface PublicParameters {
    /**
     * 
     * @type {boolean}
     * @memberof PublicParameters
     */
    analytics: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicParameters
     */
    brandingCss: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicParameters
     */
    brandingLogo: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicParameters
     */
    language: string | null;
}

export function PublicParametersFromJSON(json: any): PublicParameters {
    return PublicParametersFromJSONTyped(json, false);
}

export function PublicParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicParameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'analytics': json['analytics'],
        'brandingCss': json['branding_css'],
        'brandingLogo': json['branding_logo'],
        'language': json['language'],
    };
}

export function PublicParametersToJSON(value?: PublicParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'analytics': value.analytics,
        'branding_css': value.brandingCss,
        'branding_logo': value.brandingLogo,
        'language': value.language,
    };
}


